import { cva } from "class-variance-authority";

export { default as Avatar } from "./Avatar.vue";
export { default as AvatarFallback } from "./AvatarFallback.vue";
export { default as AvatarImage } from "./AvatarImage.vue";
export { default as AvatarBuilding } from "./AvatarBuilding.vue";
export { default as AvatarGroup } from "./AvatarGroup.vue";

export const sizes = ["xs", "sm", "md", "lg", "xl", "2xl", "3xl"];
export const shapes = ["circle", "square"];

export const fixformSrc = "/images/fixform-avatar.png";
export const buildingSrc = "/images/building.png";

export const variants = cva(
    [
        "relative",
        "inline-flex",
        "items-center",
        "justify-center",
        "font-medium",
        "avatar-text",
        "avatar-bg",
        "before:absolute",
        "before:inset-0",
        "before:z-10",
        "before:rounded-[inherit]",
        "before:shadow-[inset_0_0_0_0.75px]",
        "before:avatar-contrast-border",
        "select-none",
        "shrink-0",
        "z-0",
        "overflow-hidden",
        "focus:border-4",
        "focus:avatar-focus-border",
    ],
    {
        variants: {
            size: {
                xs: [
                    "w-5.5",
                    "h-5.5",
                    "text-[9px]",
                    "leading-[10px]",
                    "[&_i]:w-3.5",
                    "[&_i]:h-3.5",
                ],
                sm: [
                    "w-6",
                    "h-6",
                    "text-[10px]",
                    "leading-[10px]",
                    "[&_i]:w-4",
                    "[&_i]:h-4",
                ],
                md: [
                    "w-8",
                    "h-8",
                    "text-style-sm",
                    "leading-[10px]",
                    "[&_i]:w-5",
                    "[&_i]:h-5",
                ],
                lg: [
                    "w-10",
                    "h-10",
                    "text-style-base",
                    "leading-[16px]",
                    "[&_i]:w-6",
                    "[&_i]:h-6",
                ],
                xl: [
                    "w-12",
                    "h-12",
                    "text-style-xl",
                    "leading-sm",
                    "[&_i]:w-7",
                    "[&_i]:h-7",
                ],
                "2xl": [
                    "w-14",
                    "h-14",
                    "text-2xl",
                    "leading-sm",
                    "[&_i]:w-8",
                    "[&_i]:h-8",
                ],
                "3xl": [
                    "w-16",
                    "h-16",
                    "text-[28px]",
                    "leading-sm",
                    "[&_i]:w-8",
                    "[&_i]:h-8",
                ],
            },
            shape: {
                circle: ["rounded-full"],
            },
        },
        compoundVariants: [
            {
                size: "xs",
                shape: "square",
                class: ["rounded-xs"],
            },
            {
                size: "sm",
                shape: "square",
                class: ["rounded-sm"],
            },
            {
                size: "md",
                shape: "square",
                class: ["rounded-lg"],
            },
            {
                size: "lg",
                shape: "square",
                class: ["rounded-lg"],
            },
            {
                size: "xl",
                shape: "square",
                class: ["rounded-xl"],
            },
            {
                size: "2xl",
                shape: "square",
                class: ["rounded-xl"],
            },
            {
                size: "3xl",
                shape: "square",
                class: ["rounded-2xl"],
            },
        ],
        defaultVariants: {
            size: "sm",
            shape: "square",
        },
    }
);

export const avatarGroupVariants = cva([
    "ltr:-ml-1",
    "ltr:first:ml-0",
    "rtl:-mr-1",
    "rtl:first:mr-0",
    "outline",
    "outline-2",
    "outline-white",
    "group-hover:outline-secondary",
    "translate-x-0",
]);
